import type { SxProps, Theme } from '@mui/material'
import { TableContainer } from '@mui/material'
import type { ReactNode } from 'react'
interface ISimpleTableContainerProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

export default function SimpleTableContainer({ children, sx }: ISimpleTableContainerProps) {
  return <TableContainer sx={sx}>{children}</TableContainer>
}
